import { render, staticRenderFns } from "./ResumenCuentasPagos.vue?vue&type=template&id=06f234f2&"
import script from "./ResumenCuentasPagos.vue?vue&type=script&lang=js&"
export * from "./ResumenCuentasPagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports